export enum BreakPoint {
    SMALL = '768px',
    MEDIUM = '992px',
    PHONE = '480px',
    SCREEN_MD_MIN = '789px',
    SCREEN_SM_MIN = '671px',
    TABLET_PORTRAIT = '1000px'
}
